import React from 'react'
import PropTypes from 'prop-types'
import { ButtonGroup } from 'react-bootstrap'

class ButtonSelect extends React.Component {

  getValueLink = (props) => {
    let { onChange, value } = props
    return props.valueLink || { value: value, requestChange: onChange }
  }

  handleClick = (child) => {
    let { value, requestChange } = this.getValueLink(this.props)
    let keys = this.getChildKeys()
    let key = child.props.eventKey
    if (this.props.type === 'radio') {
      keys.forEach(k => value[k] = (k === key) ? true : false)
    } else {
      keys.forEach(k => value[k] = (k === key) ? !value[k] : value[k])
    }
    requestChange(value)
  }

  getChildKeys = () => {
    let keys = []
    React.Children.forEach(this.props.children, (child) => {
      keys.push(child.props.eventKey)
    })
    return keys
  }

  renderChildren = () => {
    return React.Children.map(this.props.children, (child)=> {
      let value = this.getValueLink(this.props).value || {}
      let isActive = value[child.props.eventKey] || false
      return React.cloneElement(child, {
        active: isActive,
        onClick: this.handleClick.bind(this, child)
      })
    })
  }

  render() {
    return (
      <ButtonGroup className={this.props.className} bsSize={this.props.bsSize} style={{width: '100%', padding: '6px'}}>
        {this.renderChildren()}
      </ButtonGroup>
    )
  }

}

ButtonSelect.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(['checkbox', 'radio']),
  value: PropTypes.any,
  onChange: PropTypes.func,
  valueLink: PropTypes.shape({
    value: PropTypes.any,
    requestChange: PropTypes.func.isRequired
  })
}

ButtonSelect.defaultProps = {
  value: {},
  valueLink: null,
  onChange: ()=> {},
}

export default ButtonSelect



// WEBPACK FOOTER //
// ./src/components/widgets/ButtonSelect.js